import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dialog } from "@progress/kendo-react-dialogs";
import { FloatingActionButton } from "@progress/kendo-react-buttons";
import { Badge, BadgeContainer } from '@progress/kendo-react-indicators';
import { updateAbout } from '../../actions/index.js'
import EditAboutForm from '../../components/EditAboutForm';
import { Card, CardBody, CardHeader, CardSubtitle, CardTitle } from '@progress/kendo-react-layout';
import Tooltip from '@mui/material/Tooltip';
import { formCloser } from '../../utils/formCloser.js';

const AboutSection = (props) => (
  <div style={styles.aboutSection}>
    <div style={styles.aboutSectionTitle}>
      {props.title}
    </div>
    <div style={styles.aboutSectionContent}>
      {props.content}
    </div>
  </div>
)

const DashboardAbout = () => {
  const { token, user } = useSelector(state => state.authReducer);
  const { about } = useSelector(state => state.aboutReducer);

  const [termsModal, setTermsModal] = useState(false);
  const [showAboutForm, setShowAboutForm] = useState(false);
  const [dialogProps, setDialogProps] = useState({});
  const [showDialog, setShowDialog] = useState(false);
  
  const dispatch = useDispatch();


  const aboutFormSubmit = (dataItem) => {
    dispatch(updateAbout(dataItem.id, dataItem, token, user.site.id, formCloser(setShowAboutForm)));
  }

  return (
    <>
      <Card style={styles.card}>
        <CardHeader className='k-hbox' style={styles.cardHeader}>
          <CardTitle style={styles.cardTitle}>About</CardTitle>
          <CardSubtitle style={styles.cardSubtitle}>
            <p>Control content users see inside the mobile app.</p>
          </CardSubtitle>
        </CardHeader>
        <CardBody>
          <AboutSection title='Overview' content={about.description} />
          <AboutSection 
            title='Website'
            content={(
              <a href={about.website} target="_blank">
                {about.website}
              </a>
            )}
          />
          <AboutSection title='Phone' content={about.phone} />
          <AboutSection 
            title={(
              <BadgeContainer>
                <Tooltip 
                  title="Viewed within the menu of the mobile app."
                  placement='right'
                >
                  <div>
                    Terms and Conditions
                    <Badge
                      align={{ horizontal: 'end' }}
                      fill='outline'
                      position='outside'
                      size='small'
                      style={{ border: 'none' }}
                    >
                      <span className='k-icon k-i-info' />
                    </Badge>  
                  </div>
                </Tooltip>
              </BadgeContainer>
            )}
            content={(
              <a onClick={() => setTermsModal(true)} href="#">
                View Terms and Conditions
              </a>
            )}
          />
          
          {!user.viewOnly && !user.notificationOnly && <FloatingActionButton
            onClick={() => setShowAboutForm(true)}
            icon='pencil'
            align={{ horizontal: 'end', vertical: 'top' }}
            shape='rectangle'
            positionMode='absolute'
            style={{ zIndex: 1000 }}
          />}
        </CardBody>
      </Card>

      {showAboutForm && (
        <EditAboutForm
          cancelEdit={() => setShowAboutForm(false)}
          onSubmit={(dataItem) => {
            aboutFormSubmit(dataItem);
          }}
          item={about}
        />
      )}
      {termsModal && (
        <Dialog 
          width={600}
          height={600}
          title={"Terms and Conditions"}
          onClose={() => setTermsModal(false)}
        >
          <div style={styles.termsModalContent}>
            {about.terms}
          </div>
        </Dialog>
      )}
      {showDialog &&
        <Dialog
          {...dialogProps}
          onClose={() => setShowDialog(false)}
        />}
    </>
  )
}

const styles = {
  card: {
    minWidth: 800,
    margin: 5,
  },
  cardHeader: {
    flexDirection: 'column',
  },
  cardTitle: {
    paddingTop: 10
  },
  cardSubtitle: {
    maxHeight: 35,
    marginTop: 5
  },
  aboutSection: {
    marginBottom: 20
  },
  aboutSectionTitle: {
    fontWeight: 'bold',
    fontSize: 15,
  },
  aboutSectionContent: {
    paddingTop: 5,
    whiteSpace: 'pre-line',
  },
  termsModalContent: {
    whiteSpace: 'pre-line',
  },
}

export default DashboardAbout;